import shell from "./shell.module.css";
import ui from "./ui.module.css";

type Props = {
  title: string;
  rows?: number;
};

/** Quiet placeholders while a real list is still loading. */
export function LoadList({ title, rows = 3 }: Props) {
  return (
    <div aria-busy="true" aria-live="polite">
      <h1 className={shell.pageTitle}>{title}</h1>
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className={ui.skeletonRow} />
      ))}
    </div>
  );
}
